import axios from 'axios';
import { getToken, removeToken, isTokenExpired, getRoleFromPathname } from './tokenUtils';
import store from '../../store/store';
import { logout } from '../../store/loginReducer';
import { API_ENDPOINT } from '../constants/apiConstants';

const isPublicEndpoint = (url) => {
  const publicEndpoints = [
    API_ENDPOINT.USER_AUTHENTICATION.LOGIN,
  ];
  
  return publicEndpoints.some(endpoint => url.includes(endpoint));
};

export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      if (isPublicEndpoint(config.url)) {
        return config;
      }
      
      const token = getToken();
      if (token) {
        if (isTokenExpired(token)) {
          const role = getRoleFromPathname();
          removeToken(role);
          store.dispatch(logout(role));
          window.location.href = role === 'student' ? '/student' : '/admin';
          return Promise.reject(new Error('Token expired'));
        }
        
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        console.log("no token available for protected endpoint");
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        const role = getRoleFromPathname();
        removeToken(role);
        store.dispatch(logout(role));
        if (window.location.pathname !== '/' && 
            window.location.pathname !== '/admin' && 
            window.location.pathname !== '/student') {
          window.location.href = role === 'student' ? '/student' : '/admin';
        }
        
        return Promise.reject(new Error('Unauthorized: Please login again'));
      }
      
      if (error.response?.status === 403) {
        return Promise.reject(new Error('Forbidden: You do not have permission to access this resource'));
      }
      
      return Promise.reject(error);
    }
  );
};

export const createAuthenticatedAxiosInstance = () => {
  const instance = axios.create();
  
  instance.interceptors.request.use(
    (config) => {
      if (isPublicEndpoint(config.url)) {
        return config;
      }
      
      const token = getToken();
      
      if (token && !isTokenExpired(token)) {
        config.headers.Authorization = `Bearer ${token}`;
      } else if (token && isTokenExpired(token)) {
        const role = getRoleFromPathname();
        removeToken(role);
        store.dispatch(logout(role));
        window.location.href = role === 'student' ? '/student' : '/admin';
        return Promise.reject(new Error('Token expired'));
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const role = getRoleFromPathname();
        removeToken(role);
        store.dispatch(logout(role));
        if (window.location.pathname !== '/' && 
            window.location.pathname !== '/admin' && 
            window.location.pathname !== '/student') {
          window.location.href = role === 'student' ? '/student' : '/admin';
        }
        return Promise.reject(new Error('Unauthorized: Please login again'));
      }
      return Promise.reject(error);
    }
  );
  
  return instance;
};

